<template>
	<UDialog>
		<UDialogContent class="flex flex-col items-center justify-center gap-3 border-2 border-foreground rounded">
			<NuxtImg
				src="/images/have-sub.svg"
				width="250"
				height="187" />

			<h2 class="text-center text-xl">
				شما اشتراک فعال دارید
			</h2>

			<p class="text-center text-foreground/60">
				از قبل اشتراک داری و نیازی به خرید دوباره اشتراک نیست !
			</p>
		</UDialogContent>
	</UDialog>
</template>
